export class AvatarHelperConstants {
    public static AVATAR_SKIN: string = "skin";
    public static AVATAR_PREVIEW: string = "_preview";

    // key - id form the items xml
    // value - color code
    public static avatarSkinColorsMap(): Map<number, string> {
        let map: Map<number, string> = new Map();

        // man skin colors
        map.set(10009, "#F2D4AF");
        map.set(10008, "#EFBF77");
        map.set(10007, "#B26A2F");
        map.set(10006, "#DDA66F");
        map.set(10005, "#4A250F");
        map.set(10004, "#955F2D");
        map.set(10003, "#C2844B");
        map.set(10002, "#EDA46D");
        map.set(10001, "#EEBB88");
        map.set(10000, "#DBBA9E");

        // women skin colors
        map.set(10019, "#F2D4AF");
        map.set(10018, "#B26A2F");
        map.set(10017, "#EFBF77");
        map.set(10016, "#DDA66F");
        map.set(10015, "#4A250F");
        map.set(10014, "#955F2D");
        map.set(10013, "#C2844B");
        map.set(10012, "#EDA46D");
        map.set(10011, "#EEBB88");
        map.set(10010, "#DBBA9E");

        return map;
    }
}